<template>
  <v-card class="rounded-0">
    <v-toolbar
      color="secondary"
      dark
      height="36"
      style="margin-bottom: 2px; z-index: 8">
      <v-toolbar-title>
        <v-row class="pl-2" style="margin-top: -6px">
          <button-tip btnclass="ml-0 mr-n2" @click="getNotes()" icolor="white" icon iname="mdi-update" tip="Refresh"/>
          <button-tip btnclass="mx-n2" @click="expanded=[]" icolor="white" icon
                      iname="mdi-collapse-all-outline" tip="Close All"/>
          <span
            v-if="items === 'News'"
            :style="$vuetify.breakpoint.name === 'xs'
              ? 'position: relative; top: -3px'
              : 'position: relative; top: -2px'">
            <span class="ml-1 mr-n1" :class="{'caption':$vuetify.breakpoint.xs}">My</span>
            <button-tip btnclass="mx-n1" @click="news = 'My'" icolor="white" icon iname="mdi-toggle-switch-outline"
                        tip="Switch to My News" v-if="news === 'All'" xlarge/>
            <button-tip btnclass="mx-n1" @click="news = 'All'" icolor="white" icon iname="mdi-toggle-switch-off-outline"
                        tip="Switch to All News" v-if="news === 'My'" xlarge/>
            <span class="ml-n1 mr-1 pr-2" :class="{'caption':$vuetify.breakpoint.xs}">All News</span>
          </span>
          <span
            v-else-if="items === 'Events' || items === 'Appts'"
            :style="$vuetify.breakpoint.name === 'xs'
              ? 'position: relative; top: -3px'
              : 'position: relative; top: -2px'">
            <span class="ml-1 mr-n1" :class="{'caption':$vuetify.breakpoint.xs}">My</span>
            <button-tip
              btnclass="mx-n1"
              @click="calendar = 'My'"
              icolor="white"
              icon
              iname="mdi-toggle-switch-outline"
              :tip="`Switch to My ${items === 'Appts' ? 'Appointments' : 'Events'}`"
              v-if="calendar === 'All'"
              xlarge/>
            <button-tip
              btnclass="mx-n1"
              @click="calendar = 'All'"
              icolor="white"
              icon
              iname="mdi-toggle-switch-off-outline"
              :tip="`Switch to All ${items === 'Appts' ? 'Appointments' : 'Events'}`"
              v-if="calendar === 'My'"
              xlarge/>
            <span class="ml-n1 mr-1 pr-2" :class="{'caption':$vuetify.breakpoint.xs}">
              All {{ items === 'Appts' ? ($vuetify.breakpoint.xs ? 'Appts' : 'Appointments') : 'Events' }}
            </span>
          </span>
          <span
            class="pl-2 pt-2 pr-4"
            :class="{'caption':$vuetify.breakpoint.xs}"
            :style="$vuetify.breakpoint.name === 'xs' ? 'margin-top: 6px' : ''"
            v-else>
            {{ items === 'Appts' ? 'Appointments' : 'Events' }}
          </span>
        </v-row>
      </v-toolbar-title>
      <information-dialog-icon
                               :confirm-class="$vuetify.breakpoint.xs ? 'mr-1 mb-1 title' : 'mr-3 mb-1 title'"
                               dialog-width="550" icon-color="white"
                               icon-style="margin: 2px 0 -1px" tclass="headline grey lighten-2 mb-8"
                               title="Home Info" v-if="items === 'News'">
        <div class="news-info">
          <p>If item is
            <span style="color: red">xtreme</span>, the date will be red. Ex:
            <span style="color: red">05 Mar 2022 12:46 AM</span>
          </p>
          <p>If item is
            <span style="color: blue">urgent</span>, the date will be blue. Ex:
            <span style="color: blue">01 Dec 2018 11:11 AM</span>
          </p>
          <p>Click <v-icon>mdi-collapse-all-outline</v-icon> to close expanded notes in the corresponding table.</p>
          <p>Slide switch to "All" to see everyone's news/events/appointments.</p>
          <p>Slide switch to "My" to see only your news/events/appointments.</p>
          <p>
            <b>My News</b> (switch to My): your <b>unread</b> news only, default last <b>2 weeks</b>. No date-range picker — use this as an inbox.
          </p>
          <p>
            <b>All News</b> (switch to All): everyone's news. Use the <b>Range</b> button (ex: <b>12m</b>) for how far back to load (up to 1,000 rows per page).
            If more than 1,000 rows fit in your range,
            <v-icon small>mdi-chevron-left</v-icon> <v-icon small>mdi-chevron-right</v-icon>
            arrows appear under the table for older pages.
          </p>
          <p>
            <b>Search</b> (All News): only the rows on the <b>current page</b>. If more than 1,000 rows fit in your range, use the arrows under the table to reach older pages, or pick a shorter range.
          </p>
        </div>
      </information-dialog-icon>
      <!-- Range applies to All News only; My News uses a fixed unread window (weeks:2). -->
      <div v-if="items === 'News' && news === 'All'" class="d-flex align-center justify-center flex-grow-1 home-news-toolbar-center">
        <v-menu
          v-model="newsRangeMenu"
          :close-on-content-click="false"
          offset-y
          :z-index="999">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="px-2"
              :class="$vuetify.breakpoint.xs ? 'ml-n2' : ''"
              small
              text
              :title="newsRangeTooltip"
              v-bind="attrs"
              v-on="on"
              style="min-width: 40px">
              {{ newsRangeLabel }}
            </v-btn>
          </template>
          <v-card class="pa-2" style="max-width: 320px">
            <div class="subtitle-2 mb-1">All News date range</div>
            <div class="caption mb-2">
              Loads everyone's news in this range (up to 1,000 rows per page).<span v-if="showAllNewsPager"> Use the arrows under the table for older pages.</span>
            </div>
            <div class="caption mb-4" v-if="newsRangeDraftUnit !== 'year'">
              Show last (max 52w / 24m). Use Year for older.
            </div>
            <div class="caption mb-2" v-else>Show a specific year (YYYY)</div>
            <v-form @submit.prevent="applyNewsRange" class="news-range-form">
              <v-row no-gutters class="align-center">
                <v-col cols="5">
                  <v-text-field
                    dense
                    hide-details
                    :label="newsRangeDraftUnit === 'year' ? 'Year' : 'Value'"
                    type="number"
                    :min="newsRangeDraftUnit === 'year' ? 1000 : 1"
                    :max="newsRangeDraftUnit === 'year'
                      ? 9999
                      : newsRangeDraftUnit === 'months'
                        ? 24
                        : 52"
                    :hint="newsRangeDraftUnit === 'year' ? 'YYYY' : undefined"
                    :persistent-hint="newsRangeDraftUnit === 'year'"
                    v-model.number="newsRangeDraftValue"
                  />
                </v-col>
                <v-col cols="7" class="pl-2">
                  <v-select
                    dense
                    hide-details
                    label="Unit"
                    :items="newsRangeUnits"
                    item-text="text"
                    item-value="value"
                    :menu-props="{ zIndex: 999 }"
                    v-model="newsRangeDraftUnit"
                  />
                </v-col>
              </v-row>
              <v-row no-gutters class="justify-end mt-2">
                <v-btn small text type="button" @click="newsRangeMenu = false">Cancel</v-btn>
                <v-btn small color="secondary" class="ml-2" type="submit">Apply</v-btn>
              </v-row>
            </v-form>
          </v-card>
        </v-menu>
      </div>
      <div v-else-if="items === 'News' && news === 'My' && !$vuetify.breakpoint.xs" class="flex-grow-1 d-flex align-center justify-center home-news-toolbar-center">
        <span
          class="caption white--text text--darken-1 px-1"
          :title="myNewsScopeTip">
          {{ myNewsScopeLabel }}
        </span>
      </div>
      <v-spacer v-else/>

      <v-text-field
        append-icon="mdi-magnify"
        class="mb-1 mr-1 compact-hint"
        :class="items === 'News' && $vuetify.breakpoint.xs ? 'ml-n1' : 'ml-n3'"
        clearable
        dense
        :label="$vuetify.breakpoint.name === 'xs' ? '' : 'Search'"
        single-line
        :hint="notesCountLabel"
        persistent-hint
        :style="items === 'News'
          ? {
            fontSize: $vuetify.breakpoint.name === 'xs' ? 'x-small' : undefined,
            marginTop: '4px',
            minWidth: 0,
            // 3 Feb 2026 JCH: keep News toolbar from wrapping on mobile
            maxWidth: $vuetify.breakpoint.name === 'xs'
              ? '26vw'
              : $vuetify.breakpoint.name === 'sm'
                ? '22vw'
                : '26vw'
          }
          : ($vuetify.breakpoint.name === 'xs'
            ? { fontSize: 'x-small', marginTop: '4px', maxWidth: '26vw' }
            : { marginTop: '4px', maxWidth: '26vw' }
          )"
        v-model="searchInput">
      </v-text-field>

    </v-toolbar>
    <v-data-table ref="newsTable" class="elevation-2 short-table-rows"
                  @click:row="rowClick"
                  @pagination="onTablePagination"
                  dense
                  :expanded.sync="expanded"
                  fixed-header
                  :headers="headers"
                  :height="expandedTable === true ? '80vh': ['xs','sm'].includes($vuetify.breakpoint.name) ? '27vh':'35.5vh'"
                  hide-default-footer
                  @item-expanded="getNoteFiles"
                  item-key="nid"
                  :items="notes"
                  :items-per-page="-1"
                  :loading="loading"
                  loading-text="Data loading... Please wait..."
                  style="min-height: 200px"
                  :mobile-breakpoint='0'
                  :custom-filter="notesCustomFilter"
                  :search="search"
                  :sort-by="'cstamp'"
                  :sort-desc="[['Events', 'Appts'].includes(items) ? false : true]"
                  show-expand
                  single-select
                  :style="$_cssVars">
      <template v-slot:expanded-item="{ headers, item }">
        <note-expansion :colspan="headers.length" :files="item.files || []" :key="refreshNoteFiles" :nid="item.nid"
          :html="!!item.html" :note="item.note" :tasks="item.tasks" :type="item.type" :width="'60%'"/>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-lazy>
          <v-row class="mt-n1 mb-n2">
            <button-tip
              v-if="items === 'News'"
              btnclass="mr-2"
              btnstyle="margin-top: -2px"
              @click="read(item)"
              icon
              iname="mdi-glasses"
              tip="See/Mark Read"/>
            <EditNoteOpen
              class="mb-n3"
              :style="items === 'News' ? 'margin-top: -2px' : 'margin-top: -13px'"
              v-bind="{ editPopup: true, note: item, username }"
              v-can="'note-edit'" v-if="showHomeNoteEdit(item)"/>
          </v-row>
        </v-lazy>
      </template>
      <template v-slot:item.cstamp="{ item }">
        <div :style="{color: (item.status === 'xtreme'  ? 'red' : item.status === 'urgent'  ? 'blue' : 'black' )}">
          {{ item._cstampDisplay || moment(item.cstamp, 'YYYY-MM-DDTHH:mm:ss.SSSZ').format('DD MMM YYYY \xa0 hh:mm A \xa0 ddd')}}
        </div>
      </template>
      <template v-slot:item.date="{ item }">
        <div :style="{color: (item.status === 'xtreme'  ? 'red' : item.status === 'urgent'  ? 'blue' : 'black' )}">
          {{ item.date }}
        </div>
      </template>
      <template v-slot:item.re="{ item }">
        <div v-html="replaceErrorChar(item.re)"></div>
      </template>
    </v-data-table>

    <div v-if="showAllNewsPager" class="home-news-pager d-flex align-center px-2 py-1">
      <span class="caption">{{ allNewsRowLabel }}</span>
      <v-spacer/>
      <v-btn icon small :disabled="loading || allNewsPage <= 1" @click="changeAllNewsPage(-1)">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-tooltip bottom open-delay="300" :disabled="allNewsHasNext">
        <template v-slot:activator="{ on }">
          <span v-on="on" class="d-inline-flex">
            <v-btn icon small :disabled="loading || !allNewsHasNext" @click="changeAllNewsPage(1)">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </span>
        </template>
        <span>{{ allNewsNextDisabledTip }}</span>
      </v-tooltip>
    </div>

    <HomeNotesRead @close="readersDialog = false" :note="note" :second-button="false" :username="username"
                   @marked-read="handleMarkedRead"
                   v-model="readersDialog"/>
    <snack :color="$_snack.color" :msg="$_snack.msg" :timeout="$_snack.timeout"
           v-model="$_snack.open" v-if="$_snack.cmpnt==='HomeNotes'"/>
  </v-card>
</template>

<script>
import EditNoteOpen from '@/components/search/firms/firmNotesTable/EditNoteOpen';
import HomeNotesRead from './HomeNotesRead.vue';
import NoteExpansion from '@/components/search/firms/firmNotesTable/NoteExpansion';
import { NotesAPIService, NEWS_QUERY_LIMIT } from '@/servicehandlers/NotesAPIService';
import { canShowHomeNoteEdit } from '@/helpers/noteTakeoverRights';
import _ from 'lodash';
import moment from 'moment';

const notesAPIService = new NotesAPIService();

export default {

  components: { EditNoteOpen, HomeNotesRead, NoteExpansion },
  props: ['items', 'expandedTable'],

  data() {
    return {
      expanded: [],
      groups: [],
      loading: false,
      allNewsPage: 1,
      allNewsHasNext: false,
      news: 'My',// 7 Mar 2025 JCH (merged in rebase) Will Stewart said this should be default
      calendar: 'All',// Events/Appts staff scope: 'My' or 'All'
      newsDateRangeAll: 'months:12',// 2 Feb 2026 JCH: default "All News" date range (backend format)
      newsDateRangeMy: 'weeks:2',// 2 Feb 2026 JCH: default "My News" date range (backend format)
      newsRangeMenu: false,
      // Performance: cache expensive computed properties
      _cachedNewsRangeLabel: '',
      _cachedNewsRangeLabelDeps: '',
      newsRangeDraftUnit: 'weeks',
      newsRangeDraftValue: 2,
      newsRangeUnits: [
        { text: 'Weeks', value: 'weeks' },
        { text: 'Months', value: 'months' },
        { text: 'Year (YYYY)', value: 'year' },
      ],
      filteredCount: null, // Stores filtered count for X/Y display
      note: {},// note to pass to HomeNotesRead.vue dialog - to show who has read that note
      notes: [],
      readersDialog: false,
      refreshNoteFiles: false,
      searchInput: '',
      search: '',
      searchDebouncer: null,
      username: '',
    }
  },

  watch: {
    expanded() {
      this.$emit('expandedLengthChanged', this.expanded.length, this.items );
    },
    news() {
      this.allNewsPage = 1;
      if (this.newsRangeMenu) this.newsRangeMenu = false;
      this.getNotes();
    },
    calendar() {
      if (['Events', 'Appts'].includes(this.items)) this.getNotes();
    },
    newsRangeMenu(v) {
      if (v) this.loadNewsRangeDraft();
    },
    searchInput(v) {
      const hasInput = !!String(v || '').trim();

      if (!hasInput) {
        this.searchDebouncer.cancel();
        this.search = '';
        this.filteredCount = null;
        return;
      }

      this.searchDebouncer(v);
    },

    // When debounced search clears, reset filtered-count state.
    search(newVal) {
      if (!String(newVal || '').trim()) {
        this.filteredCount = null;
        return;
      }
    },
    '$vuetify.breakpoint.name'() {// if not small screen, trigger reset of tables' heights
      this.$emit('resize', this.expanded.length, this.items );
    }
  },

  computed: {
    isDev() {
      return process.env.NODE_ENV === 'development';
    },

    isSearching() {
      const input = String(this.searchInput || '').trim();
      if (!input) return false;
      return input !== String(this.search || '').trim();
    },

    notesCountTotal() {
      return Array.isArray(this.notes) ? this.notes.length : 0;
    },
    notesCountLabel() {
      const total = this.notesCountTotal;
      if (total === 0) return '0/0';

      const fmt = (n) => n.toLocaleString('en', { useGrouping: true });

      if (this.isSearching) return `.../${fmt(total)}`;

      // Always show "X/Y" (no filter => "Y/Y")
      const filtered = this.filteredCount !== null ? this.filteredCount : total;
      return `${fmt(filtered)}/${fmt(total)}`;
    },


    newsRangeLabel() {
      // Performance: cache expensive computation, only recalculate when deps change
      const deps = `${this.items}-${this.news}-${this.newsDateRangeMy}-${this.newsDateRangeAll}-${this.$vuetify.breakpoint.name}`;
      if (this._cachedNewsRangeLabelDeps !== deps) {
        this._cachedNewsRangeLabelDeps = deps;
        if (this.items !== 'News') {
          this._cachedNewsRangeLabel = '';
        } else if (this.news !== 'All') {
          this._cachedNewsRangeLabel = '';
        } else {
          const current = this.newsDateRangeAll;
          const fallback = 'months:12';
          const norm = String(current || fallback).trim().toLowerCase();
          const isXs = this.$vuetify.breakpoint.name === 'xs';
          const year = String(norm).match(/^year:(\d{4})$/);
          if (year) {
            this._cachedNewsRangeLabel = isXs ? `${year[1]}` : `Year ${year[1]}`;
          } else {
            const m = String(norm).match(/^(days|weeks|months):(\d+)$/);
            if (!m) {
              this._cachedNewsRangeLabel = isXs ? '2w' : '2 weeks';
            } else {
              const n = parseInt(m[2], 10);
              const unitLong = m[1];
              if (isXs) {
                const unitShort = unitLong === 'days' ? 'd' : unitLong === 'weeks' ? 'w' : 'm';
                this._cachedNewsRangeLabel = `${n}${unitShort}`;
              } else {
                const singular = unitLong.replace(/s$/, '');
                this._cachedNewsRangeLabel = `${n} ${n === 1 ? singular : unitLong}`;
              }
            }
          }
        }
      }
      return this._cachedNewsRangeLabel;
    },

    newsRangeTooltip() {
      if (this.items !== 'News' || this.news !== 'All') return '';
      const current = this.newsDateRangeAll;
      const fallback = 'months:12';
      const norm = String(current || fallback).trim().toLowerCase();
      const year = String(norm).match(/^year:(\d{4})$/);
      if (year) return `All News range: year ${year[1]} (click to change)`;
      const m = String(norm).match(/^(days|weeks|months):(\d+)$/);
      if (!m) return 'All News date range (click to change)';
      const n = parseInt(m[2], 10);
      const unitLong = m[1];
      const singular = unitLong.replace(/s$/, '');
      return `All News range: last ${n} ${n === 1 ? singular : unitLong} (click to change)`;
    },

    myNewsScopeLabel() {
      const norm = String(this.newsDateRangeMy || 'weeks:2').trim().toLowerCase();
      const m = norm.match(/^(days|weeks|months):(\d+)$/);
      const year = norm.match(/^year:(\d{4})$/);
      let rangeText = '2 weeks';
      let compactRange = '2w';
      if (year) {
        rangeText = `year ${year[1]}`;
        compactRange = year[1];
      } else if (m) {
        const n = parseInt(m[2], 10);
        const unit = m[1];
        rangeText = `${n} ${n === 1 ? unit.replace(/s$/, '') : unit}`;
        const unitShort = unit === 'days' ? 'd' : unit === 'weeks' ? 'w' : 'm';
        compactRange = `${n}${unitShort}`;
      }
      if (this.$vuetify.breakpoint.xs) return `Unread · ${compactRange}`;
      return `unread only · ${rangeText}`;
    },

    myNewsScopeTip() {
      const norm = String(this.newsDateRangeMy || 'weeks:2').trim().toLowerCase();
      const m = norm.match(/^(days|weeks|months):(\d+)$/);
      const year = norm.match(/^year:(\d{4})$/);
      let rangeText = '2 weeks';
      if (year) rangeText = `year ${year[1]}`;
      else if (m) {
        const n = parseInt(m[2], 10);
        const unit = m[1];
        rangeText = `${n} ${n === 1 ? unit.replace(/s$/, '') : unit}`;
      }
      return `My News: unread only · ${rangeText}. Switch to All News to browse everyone's news by date range.`;
    },

    headers() {
      const actionsHeader = { text: '', value: 'actions', width: '100px', sortable: false, filterable: false };
      let hdrEvents = [// column headers for events
        actionsHeader,
        { text: 'Date', value: 'cstamp', width: '230px' },
        { text: 'Re', value: 're', width: '700px', align: 'start' },
      ];
      let news = [// add for news
        { text: 'News', value: 'sort', width: '500px' },
      ];
      let hdrAppointments = [...hdrEvents, ...[{value: 'staff', width: '100px'}]];// add staff for appointments
      hdrAppointments = hdrAppointments.map(h => h.value === 'staff'
        ? { text: 'For', value: 'staff', width: '100px' }
        : h);
      let hdrNews = [
        ...hdrAppointments,
        ...news
      ];// add actions & news
      let hdrs = this.items === 'News' ? hdrNews: this.items === 'Appts' ? hdrAppointments : hdrEvents;
      return hdrs;
    },

    showAllNewsPager() {
      return this.items === 'News'
        && this.news === 'All'
        && !this.loading
        && !String(this.search || '').trim()
        && (this.allNewsPage > 1 || this.allNewsHasNext);
    },

    allNewsRowLabel() {
      const count = this.notesCountTotal;
      if (!count) return 'No rows on this page';
      const start = (this.allNewsPage - 1) * NEWS_QUERY_LIMIT + 1;
      const end = start + count - 1;
      const fmt = (n) => n.toLocaleString('en', { useGrouping: true });
      return `Rows ${fmt(start)}–${fmt(end)}`;
    },

    allNewsNextDisabledTip() {
      return this.notesCountTotal
        ? 'No more news in this date range'
        : 'No news on this page';
    },
  },

  created() {
    document.title = 'Home';
    this.username = this.$store.getters.username;
    this.groups = this.$store.getters.groups;
    // Debounce search to keep large tables responsive while typing (esp. large News lists)
    this.searchDebouncer = _.debounce((v) => {
      this.search = v;
    }, 200);
    this.getNotes();
  },

  beforeDestroy() {
    // Clean up search debouncer
    if (this.searchDebouncer) {
      this.searchDebouncer.cancel();
    }
  },

  methods: {
    showHomeNoteEdit(item) {
      return canShowHomeNoteEdit(item, {
        isAdmin: this.groups.includes('admin'),
        canNoteOverride: this.$_can('note-override'),
      });
    },

    onTablePagination(pagination) {
      // pagination.itemsLength reflects the filtered items length (when server-items-length is not used).
      const debouncedSearch = String(this.search || '').trim();

      if (!debouncedSearch) {
        this.filteredCount = null;
        return;
      }

      const itemsLength = pagination?.itemsLength;
      this.filteredCount = Number.isFinite(itemsLength) ? itemsLength : null;
    },

    notesCustomFilter(value, search, item) {
      const needle = String(search || '').toLowerCase();
      if (!needle) return true;

      // Make date/day search match what users see in the Date column.
      if (item && item._cstampSearch && value === item.cstamp) {
        return String(item._cstampSearch).toLowerCase().includes(needle);
      }

      if (value === null || value === undefined) return false;
      return String(value).toLowerCase().includes(needle);
    },

    getNoteFiles(expanded) {
      if (expanded.value === false) return;// only check for files if item expanded (true), not if it was closed (false)

      // 4 Feb 2026 JCH: For performance, list fetches don't include note/tasks; fetch body on demand when expanding.
      if (expanded.item && expanded.item.nid && expanded.item._bodyLoaded !== true) {
        notesAPIService.getNote(expanded.item.nid, this.$router).then((full) => {
          if (!full) return;
          // Ensure reactivity when properties were not present in the list payload (Vue2).
          this.$set(expanded.item, 'note', full.note || '');
          this.$set(expanded.item, 'tasks', full.tasks || '');
          this.$set(expanded.item, 'html', !!full.html);
          this.$set(expanded.item, '_bodyLoaded', true);
        }).catch((e) => {
          console.debug('❌ Failed to load note body:', e);
          this.$set(expanded.item, '_bodyLoaded', true);
        });
      }

      if (!(expanded.item.files && expanded.item.files.length)) {// if there are not files already call API
        notesAPIService.getNoteFiles(expanded.item.nid, this.$router).then((files) => {
          expanded.item.files = files;
          this.refreshNoteFiles = !this.refreshNoteFiles;
        }).catch((e) => {
          console.debug('❌ Failed to load note files:', e);
          expanded.item.files = [];
        });
      }
    },

    getNotes() {
      this.loading = true;
      // remove final s and change to lowercase to get note type of 'event', or 'appt' for getCalendarNotesByType
      const type = this.items.toLowerCase().substring(0, this.items.length-1);

      let req;
      if (this.items === 'News') {
        req = (this.news === 'My')
          ? notesAPIService.getNewsNotesByUsername(this.username, this.$router, this.newsDateRangeMy)
          : notesAPIService.getAllNewsNotes(this.$router, this.newsDateRangeAll, this.allNewsPage);
      } else if (this.items === 'Events' || this.items === 'Appts') {
        // My: staff === username OR staff === '' ; All: any staff (including blank)
        const staff = this.calendar === 'My' ? [this.username, ''] : undefined;
        req = notesAPIService.getCalendarNotesByType(type, this.$router, staff);
      } else {
        this.loading = false;
        return;
      }

      req.then(notes => this.processNotes(notes))
        .catch((e) => {
          // Avoid dev overlay "Uncaught runtime errors" and keep Home usable
          console.debug(`❌ Failed to load ${this.items}:`, e);
          this.notes = [];
          this.allNewsHasNext = false;
          this.loading = false;
        });
    },

    processNotes(notes) {
      const rows = Array.isArray(notes) ? notes : [];
      // Vuetify v-data-table requires stable unique keys; backend can return duplicate nids.
      let normalized = _.uniqBy(rows, 'nid');

      // Guardrail: Events/Appts should only show yesterday (start of day) and future.
      if (['Events', 'Appts'].includes(this.items)) {
        const start = moment().subtract(1, 'day').startOf('day');
        normalized = normalized.filter((note) => {
          if (!note || !note.cstamp) return true; // keep if missing/unknown
          const m = moment(note.cstamp, moment.ISO_8601, true);
          if (!m.isValid()) return true; // keep if unparseable
          return m.isSameOrAfter(start);
        });
      }

      this.notes = normalized;
      if (this.items === 'News' && this.news === 'All') {
        this.allNewsHasNext = normalized.length === NEWS_QUERY_LIMIT;
      }

      // Pre-compile formatters once (not per item) - MAJOR performance boost
      const searchFormat = 'DD MMM YYYY hh:mm A ddd dddd';
      const displayFormat = 'DD MMM YYYY \xa0 hh:mm A \xa0 ddd';

      for (let note of this.notes) {// for each note, if expanded, get files
        // Make table search match what users see (e.g. "tues" should match Tuesday in the formatted date).
        if (note && note.cstamp) {
          const m = moment(note.cstamp, moment.ISO_8601, true);
          if (m.isValid()) {
            note._cstampSearch = `${m.format(searchFormat)} ${note.status || ''}`;
            note._cstampDisplay = m.format(displayFormat);
          } else {
            note._cstampSearch = '';
            note._cstampDisplay = '';
          }
        } else {
          note._cstampSearch = '';
          note._cstampDisplay = '';
        }

        // 4 Feb 2026 JCH: For performance, list payload omits body fields; ensure placeholders exist (Vue2 reactivity).
        // Only set if missing to avoid unnecessary Vue reactivity updates
        if (note.note === undefined) note.note = '';
        if (note.tasks === undefined) note.tasks = '';

        if (this.expanded.some(x => x.nid === note.nid)) {
          notesAPIService.getNoteFiles(note.nid, this.$router).then((files) => {
            note.files = files;
            this.refreshNoteFiles = !this.refreshNoteFiles;
          }).catch((e) => {
            console.debug('❌ Failed to load note files:', e);
            note.files = [];
          });
        }
      }
      this.loading = false;
    },

    read(note) {// open dialog to mark note read and/or show readers list
      this.note = note;
      this.readersDialog = true;
    },

    replaceErrorChar(text) {
      return text.replace(/�/g, "'");
    },

    rowClick: function (item, row) {
      row.select(true);
    },

    handleMarkedRead() {
      // 2 Feb 2026 JCH: "My News" is unread-only; refresh after marking read so item disappears.
      if (this.items === 'News' && this.news === 'My') this.getNotes();
    },

    loadNewsRangeDraft() {
      const current = this.newsDateRangeAll;
      const fallback = 'months:12';
      const norm = String(current || fallback).trim().toLowerCase();
      const year = String(norm).match(/^year:(\d{4})$/);
      if (year) {
        this.newsRangeDraftUnit = 'year';
        this.newsRangeDraftValue = parseInt(year[1], 10);
        return;
      }
      const m = String(norm).match(/^(days|weeks|months):(\d+)$/);
      this.newsRangeDraftUnit = m ? m[1] : 'weeks';
      this.newsRangeDraftValue = m ? parseInt(m[2], 10) : 2;
    },

    applyNewsRange() {
      if (this.news !== 'All') return;

      const unit = this.newsRangeDraftUnit === 'months' ? 'months'
        : this.newsRangeDraftUnit === 'year' ? 'year'
          : 'weeks';

      let range;
      if (unit === 'year') {
        const year = parseInt(this.newsRangeDraftValue, 10);
        if (!Number.isFinite(year)) {
          this.$store.dispatch('SET_SNACK', {
            cmpnt: 'HomeNotes',
            open: true,
            color: 'error',
            msg: 'Enter a 4-digit year (YYYY).',
          });
          return;
        }
        if (year < 1000 || year > 9999) {
          this.$store.dispatch('SET_SNACK', {
            cmpnt: 'HomeNotes',
            open: true,
            color: 'error',
            msg: 'Year must be 1000-9999.',
          });
          return;
        }

        range = `year:${year}`;
      } else {
        // Guardrail: cap to prevent slowdowns on large datasets
        const max = unit === 'months' ? 24 : 52;
        let raw = parseInt(this.newsRangeDraftValue, 10);
        if (!Number.isFinite(raw)) raw = unit === 'months' ? 12 : 2;
        const value = Math.min(max, Math.max(1, raw));
        if (raw > max) {
          this.$store.dispatch('SET_SNACK', {
            cmpnt: 'HomeNotes',
            open: true,
            color: 'secondary',
            msg: `Range limited to ${max} ${unit} for performance. Use Year for older.`,
          });
        }
        this.newsRangeDraftValue = value;
        range = `${unit}:${value}`;
      }

      this.newsDateRangeAll = range;

      this.newsRangeMenu = false;
      this.allNewsPage = 1;
      this.getNotes();
    },

    changeAllNewsPage(delta) {
      const next = this.allNewsPage + delta;
      if (next < 1) return;
      this.allNewsPage = next;
      this.expanded = [];
      this.getNotes();
      this.$nextTick(() => {
        const table = this.$refs.newsTable;
        const wrapper = table && table.$el ? table.$el.querySelector('.v-data-table__wrapper') : null;
        if (wrapper) wrapper.scrollTop = 0;
      });
    },


  },

}
</script>

<style>
  /* Keep table rows compact, but don't squeeze the loading/empty text row */
  .v-data-table.short-table-rows tbody tr:not(.v-data-table__empty-wrapper) td {
    height: 18px !important;
  }
  .v-data-table.short-table-rows .v-data-table__empty-wrapper td {
    height: auto !important;
    padding-top: 12px !important;
    padding-bottom: 12px !important;
    line-height: 1.25 !important;
  }
  .news-info { line-height: 1.4; font-size: 0.95rem; }
  .news-info p { margin: 0 0 24px 0 !important; }
  @media (max-width: 600px) { .news-info p { margin-bottom: 18px !important; } }

  .home-news-pager { border-top: 1px solid rgba(0, 0, 0, 0.12); min-height: 32px; }
  .news-range-form { padding-top: 6px; }
  .home-news-toolbar-center { padding-top: 6px; }
  @media (max-width: 600px) { .home-news-toolbar-center { padding-top: 0; } }

  /* Force the dense text field container to be more compact */
  .compact-hint.v-input--dense .v-input__control {
    margin-bottom: 0 !important;
  }

  /* Lower clear + search icons (keep far-right) */
  .compact-hint.v-input--dense .v-input__icon--clear,
  .compact-hint.v-input--dense .v-input__icon--append {
    transform: translateY(3px) !important;
  }

  /* Move "Search" label closer to the underline */
  .compact-hint.v-input--dense .v-label:not(.v-label--active) {
    top: 7px !important; /* default dense is 4px */
  }

  /* Count label in hint: fixed rail fits "1,000/1,000" + right-justified text */
  .compact-hint.v-input--dense .v-messages {
    flex: 0 0 100px !important; /* fixed-width rail */
    width: 100px !important;
    min-width: 100px !important;
    max-width: 100px !important;
    margin-top: -2px !important; /* closer to input line, avoid clipping */
    padding: 0 !important;
    min-height: 14px !important; /* match Vuetify default details height */
  }

  .compact-hint.v-input--dense .v-messages__message {
    width: 100% !important;
    display: block !important;
    font-size: 13px !important;
    line-height: 13px !important;
    font-weight: 800 !important;
    color: rgba(255,255,255,1) !important;
    text-shadow: 0 1px 2px rgba(0,0,0,0.55) !important;
    font-family: 'Courier New', monospace !important;
    font-variant-numeric: tabular-nums !important;
    text-align: right !important;
    padding-right: 20px !important; /* slide x/y left */
    box-sizing: border-box !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    word-break: normal !important;
    overflow-wrap: normal !important;
    hyphens: none !important;
  }
</style>
